import { PipeTransform, Pipe } from "@angular/core";
import { Shopper } from "../Model/Shopper.Model";

@Pipe({
  name: 'ShopperFilter',
  standalone: false
})
export class ShopperFilterPipe implements PipeTransform {

  transform(Shoppers: Shopper[], searchTerm: string, field: string): Shopper[] {
    if (!Shoppers || !searchTerm) {
      return Shoppers;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    return Shoppers.filter(shopper =>
      this.matchesSearchTerm(shopper, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(shopper: Shopper, term: string): boolean {
    return (
      this.stringMatches(shopper.promoDepthTypeLabel, term) ||
      this.stringMatches(shopper.promoTypeCode, term) ||
      this.stringMatches(shopper.shopperTypeCode, term) ||
      this.stringMatches(shopper.supportLevelLabel, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }
}
